<template>
  <ModuleWrapper :moduleId="moduleId" :image="imageSrcPath('assets/branding/logo.svg')" title="Logo">
    <template #main>
      <ImageUploadButton
        label="Upload a transparent PNG, JPG, or JPEG max 1600x1600px"
        :image="logoURL"
        :acceptedTypes="['.png', '.jpg', '.jpeg', '.webp']"
        :imageValidation="logoImageValidation"
        :s3BucketPath="s3BucketPath"
        :security="filestackSecurity"
        @changeImageUrl="handleImageUrlChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import logger from '@goldcast/logger';
import { mapGetters, mapMutations } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ImageUploadButton from '../components/ImageUploadButton.vue';

import { getFilestackSecurity } from '@/components/core/Filestack/filestackSecurity';
import { GET_RESOURCES_PATH, LOGO_IMG_VALIDATION } from '@/constants';

export default {
  name: 'Logo',
  components: {
    ModuleWrapper,
    ImageUploadButton
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      s3BucketPath: `${GET_RESOURCES_PATH(this.$route.params.eventId)}`,
      logoImageValidation: LOGO_IMG_VALIDATION,
      filestackSecurity: null
    };
  },
  async mounted() {
    if (this.$store.getters['org/isSignedFilestackUploadsEnabled']) {
      try {
        const { security } = await getFilestackSecurity({
          intent: 'event_asset',
          assetKind: 'image',
          event: this.$route.params.eventId
        });
        this.filestackSecurity = security;
      } catch (e) {
        logger.warn('Failed to fetch Filestack security, upload will fail', e);
      }
    }
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    }),
    logoURL() {
      const moduleKeys = ['logo_url'];
      const moduleData = this.getInitialModuleData(moduleKeys);
      return moduleData.logo_url;
    }
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInEvent: 'setChangesMadeInEvent'
    }),
    handleImageUrlChange(url) {
      this.setChangesMadeInEvent({ logo_url: url || null });
    }
  }
};
</script>
